import ContactInformation from './ContactInformation';

export { ContactInformation };
export default ContactInformation;
